import { normalizeApiBaseUrl } from './api-base';

export const API_BASE_URL = normalizeApiBaseUrl(import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api');
export const MACHINE_BASE_URL = normalizeApiBaseUrl(import.meta.env.VITE_MACHINE_BASE_URL || 'https://api.dev.kim.cc/api');
